import { ProgressSteps } from "@/components/ui/ProgressSteps";
import { Button } from "@/components/ui/button";

export const ComplaintLifecycleCard = ({ complaint, onDownloadPdf, onAuditTrail }) => {
  const steps = ["Registered", "In Review", "Processing", "Resolved"];
  const statusMap = {
    Created: 0,
    Acknowledged: 1,
    InReview: 2,
    Resolved: 3,
    Archived: 3,
  };

  const current = statusMap[complaint?.status] ?? 0;

  return (
    <div className="card" data-testid="complaint-lifecycle-card">
      <div className="card-head">
        <h3>Lifecycle Track: {complaint?.complaint_id || "-"}</h3>
      </div>

      <ProgressSteps items={steps} current={current} />

      <div className="card-body" data-testid="complaint-lifecycle-content">
        <div className="split-info-grid">
          <div className="info-box" data-testid="assigned-desk-box">
            <div className="info-label">Assigned Desk</div>
            <div className="info-value">{complaint?.booth_id || "Unassigned"}</div>
          </div>
          <div className="info-box" data-testid="sla-box">
            <div className="info-label">Current Escalation Level</div>
            <div className="info-value accent">Level {complaint?.current_level || 1}</div>
          </div>
        </div>

        <div className="inline-actions">
          <Button variant="outline" onClick={() => onDownloadPdf(complaint?.complaint_id)} data-testid="download-pdf-button">
            Get Full PDF Copy
          </Button>
          <Button variant="outline" onClick={() => onAuditTrail(complaint?.complaint_id)} data-testid="audit-trail-button">
            Full Audit Trail
          </Button>
        </div>
      </div>
    </div>
  );
};
